import { nanoid } from '@reduxjs/toolkit';

import { ToastList } from 'components/global/ToastManager';

const useAlert = () => {
	const addAlerts = (alert) => {
		alert.id = nanoid();
		ToastList.push(alert);
		window.dispatchEvent(new Event('updateToastList'));
	};

	const showSuccess = (alert) => {
		addAlerts({
			type: 'success',
			header: alert?.header ?? 'alert.success',
			message: alert?.message ?? 'alert.operationCompletedSuccessfully',
			...alert
		});
	};

	const showError = (alert) => {
		addAlerts({
			type: 'error',
			header: alert?.header ?? 'alert.oops',
			message: alert?.message ?? 'alert.anErrorOccurred',
			...alert
		});
	};

	const showInfo = (alert) => {
		addAlerts({ type: 'info', ...alert });
	};

	const showWarning = (alert) => {
		addAlerts({ type: 'warning', ...alert });
	};

	const showUpdate = (alert) => {
		addAlerts({ type: 'update', ...alert });
	};

	return {
		showSuccess,
		showError,
		showInfo,
		showWarning,
		showUpdate
	};
};

export default useAlert;
